import { Button, ButtonGroup, Grid, Paper, Box, Typography } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import AlertDialog from "../../../components/alert-dialog/AlertDialog";
import { EditableHeading } from "../../../components/editable-heading/EditableHeading";
// Actions
import { HeaderBlock } from "../../../components/header-block/HeaderBlock";

import { Loading } from "../../../components/loading/Loading";
import PageContainer from "../../../components/page-container/PageContainer";
import { DeleteModal } from "../../../containers/delete-modal/DeleteModal";
import GenericPickerModal from "../../../containers/generic-picker-modal/GenericPickerModal";
import { getCategories, getCategoriesForIds } from "../../../state/actions/CategoryActions";
import { addEntitiesToProductGroup, getGroup, removeEntitiesFromProductGroup, removeGroups, updateGroup } from "../../../state/actions/GroupActions";
import { getMasterTags, getProducts, getProductsForIds } from "../../../state/actions/ProductActions";
import { EntityType } from "../../../state/constants/EntityType";
import styles from "./ViewProductGroupingPage.module.scss";
import ListableCard from "../../../components/listable-card/ListableCard";
import { withTranslation } from "react-i18next";
import i18n from "../../../i18n";
import { getProductGroupDefaultType } from "../../../state/constants/ProductGroupDefaultType";
import { SalesOrgIds } from "state/constants/SalesOrgIds";
import ProductPickerModal from "containers/generic-picker-modal/ProductPickerModal";

var productGroupId = "";

var mode = {
  EXCLUDED_PRODUCTS: "EXCLUDED_PRODUCTS",
  INCLUDED_PRODUCTS: "INCLUDED_PRODUCTS",
  EXCLUDED_CATEGORIES: "EXCLUDED_CATEGORIES",
  INCLUDED_CATEGORIES: "INCLUDED_CATEGORIES",
  EXCLUDED_MASTER_TAGS: "EXCLUDED_MASTER_TAGS",
  INCLUDED_MASTER_TAGS: "INCLUDED_MASTER_TAGS"
};

class ViewProductGroupingPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      loadingProductInclusion: false,
      loadingProductExclusion: false,
      loadingCategoryInclsion: false,
      loadingCategoryExclusion: false,
      loadingMasterTagInclusion: false,
      loadingMasterTagExclusion: false,
      groupDetails: false,
      productModalOpen: false,
      categoryModalOpen: false,
      masterTagModalOpen: false,
      masterTagDeleteModalOpen: false,
      categoryDeleteModalOpen: false,
      productDeleteModalOpen: false,
      isEditing: false,
      name: props.group ? props.group.Name : "",
      group: props.group,
      mode: "",
      deleteAlertShowing: false,
      masterTagsToDelete: [],
      categoriesToDelete: [],
      productsToDelete: [],

      isDefualtProductGroup: props.group ? this.checkDefault(props.group.id) : false
    };
  }

  checkDefault(id) {
    const defaultGroups = getProductGroupDefaultType()
    return defaultGroups[id] != null;
  }

  getProductGroup(id = null) {
    this.setState({
      loading: true, loadingCategoryInclusion: true,
      loadingCategoryExclusion: true, loadingProductInclusion: true,
      loadingProductExclusion: true
    });

    productGroupId = id || this.props.match.params.productGroupId;

    this.props.getGroup(productGroupId, () => {
      if (this.props.group) {
        let includedCategories = this.props.group.IncludedCategories;
        let excludedCategories = this.props.group.ExcludedCategories;

        let includedProducts = this.props.group.IncludedProducts;
        let excludedProducts = this.props.group.ExcludedProducts;

        if (includedCategories === undefined) {
          includedCategories = [];
        }

        if (excludedCategories === undefined) {
          excludedCategories = [];
        }

        if (includedProducts === undefined) {
          includedProducts = [];
        }

        if (excludedProducts === undefined) {
          excludedProducts = [];
        }

        let allCategories = includedCategories.concat(excludedCategories);
        let allProducts = includedProducts.concat(excludedProducts);

        this.setState({
          loading: false,
          name: this.props.group.Name,
          group: this.props.group,
          isDefualtProductGroup: this.checkDefault(this.props.group.id)
        })

        this.props.getCategoriesForIds(allCategories, () => {
          this.setState({
            loadingCategoryInclusion: false,
            loadingCategoryExclusion: false
          });
        });

        this.props.getProductsForIds(allProducts, () => {
          this.setState({
            loadingProductInclusion: false,
            loadingProductExclusion: false
          });
        });
      }
    });
  }

  componentDidMount() {
    this.getProductGroup()
    this.unlisten = this.props.history.listen((params) => {
      const url = params.pathname.split("/")
      if (url[1] === "product-groupings") {
        this.getProductGroup(url[2])
      }
    });
  }

  deleteGroup() {
    this.props.removeGroups([productGroupId], () => {
      this.props.history.push("/product-groupings");
    });
  }

  componentWillUnmount() {
    this.unlisten();
  }

  componentDidUpdate() {

    if (JSON.stringify(this.props.group) !== JSON.stringify(this.state.group)) {
      this.setState({
        name: this.props.group.Name,
        group: this.props.group,
        isDefualtProductGroup: this.checkDefault(this.props.group.id)
      });
    }
  }

  editGroup() {
    productGroupId = this.props.match.params.productGroupId;

    if (this.state.isEditing && this.state.changeOccurred) {
      this.props.updateGroup(productGroupId, { name: this.state.name }, () => {
        console.log("Done updating group...");
        this.setState({ name: this.props.group.name });
      });
    }
    this.setState({ isEditing: !this.state.isEditing });
  }

  getProductsForIds(productIds) {
    if (productIds !== undefined) {
      return productIds.map(productId => {
        const product = this.props.products[productId];

        if (product !== undefined) {
          return { id: product.id, Name: product.ProductDisplayName != null ? product.ProductDisplayName : product.ProductName };
        }

        return { id: productId, Name: this.props.t('product-group.unknown-product'), notClickable: true };
      });
    }

    return [];
  }

  getCategoriesForIds(categoryIds) {
    if (categoryIds !== undefined) {
      return categoryIds.map(categoryId => {
        const category = this.props.categories[categoryId];

        if (category !== undefined) {
          return { id: category.id, Name: category.Name };
        }

        return { id: categoryId, Name: this.props.t('product-group.unknown-category'), notClickable: true };
      });
    }

    return [];
  }

  getMasterTagsForIds(masterTagIds) {
    if (masterTagIds !== undefined) {
      return masterTagIds.map(masterTagId => {
        return { id: masterTagId, Name: masterTagId };
      });
    }

    return [];
  }

  getContentGrid(group) {
    const cards = [
      { type: "title", title: this.props.t('product-group.inclusions') },


      {
        add: this.props.t('product-group.include-product'),
        buttonAction: () => {
          this.setState({
            productModalOpen: true,
            mode: mode.INCLUDED_PRODUCTS
          });
        },
        handleDelete: (products) => {
          this.setState({
            productDeleteModalOpen: true,
            mode: mode.INCLUDED_PRODUCTS,
            productsToDelete: products
          });
        },
        isLoading: () => { return this.state.loadingProductInclusion },
        title: this.props.t('product-group.included-products'),
        emptyPlaceholder: this.props.t('product-group.no-products-included'),
        data: this.getProductsForIds(group.IncludedProducts),
        type: "products"
      },
      {
        add: this.props.t('product-group.include-category'),
        buttonAction: () => {
          this.setState({
            categoryModalOpen: true,
            mode: mode.INCLUDED_CATEGORIES
          });
        },
        handleDelete: (categories) => {
          this.setState({
            categoryDeleteModalOpen: true,
            mode: mode.INCLUDED_CATEGORIES,
            categoriesToDelete: categories
          });
        },
        isLoading: () => { return this.state.loadingCategoryInclusion },
        title: this.props.t('product-group.included-categories'),
        emptyPlaceholder: this.props.t('product-group.no-categories-included'),
        data: this.getCategoriesForIds(group.IncludedCategories),
        type: "categories"
      },
      {
        add: this.props.t('product-group.include-master-tag'),
        buttonAction: () => {
          this.setState({
            masterTagModalOpen: true,
            mode: mode.INCLUDED_MASTER_TAGS
          });
        },
        handleDelete: (masterTags) => {
          this.setState({
            masterTagDeleteModalOpen: true,
            mode: mode.INCLUDED_MASTER_TAGS,
            masterTagsToDelete: masterTags
          });
        },
        isLoading: () => { return this.state.loadingMasterTagInclusion },
        title: this.props.t('product-group.included-master-tags'),
        emptyPlaceholder: this.props.t('product-group.no-master-tags-included'),
        data: this.getMasterTagsForIds(group.IncludedMasterTags),
        type: "tags"
      },
      { type: "title", title: this.props.t('product-group.exclusions') },
      {
        add: this.props.t('product-group.exclude-product'),
        buttonAction: () => {
          this.setState({
            productModalOpen: true,
            mode: mode.EXCLUDED_PRODUCTS
          });
        },
        handleDelete: (products) => {
          this.setState({
            productDeleteModalOpen: true,
            mode: mode.EXCLUDED_PRODUCTS,
            productsToDelete: products
          });
        },
        isLoading: () => { return this.state.loadingProductExclusion },
        title: this.props.t('product-group.excluded-products'),
        emptyPlaceholder: this.props.t('product-group.no-products-excluded'),
        data: this.getProductsForIds(group.ExcludedProducts),
        type: "products"
      },
      {
        add: this.props.t('product-group.exclude-category'),
        buttonAction: () => {
          this.setState({
            categoryModalOpen: true,
            mode: mode.EXCLUDED_CATEGORIES
          });
        },
        handleDelete: categories => {
          this.setState({
            categoryDeleteModalOpen: true,
            mode: mode.EXCLUDED_CATEGORIES,
            categoriesToDelete: categories
          });
        },
        isLoading: () => { return this.state.loadingCategoryExclusion },
        title: this.props.t('product-group.excluded-categories'),
        emptyPlaceholder: this.props.t('product-group.no-categories-excluded'),
        data: this.getCategoriesForIds(group.ExcludedCategories),
        type: "categories"
      },
      {
        add: this.props.t('product-group.exclude-master-tag'),
        buttonAction: () => {
          this.setState({
            masterTagModalOpen: true,
            mode: mode.EXCLUDED_MASTER_TAGS
          });
        },
        handleDelete: masterTags => {
          this.setState({
            masterTagDeleteModalOpen: true,
            mode: mode.EXCLUDED_MASTER_TAGS,
            masterTagsToDelete: masterTags
          });
        },
        isLoading: () => { return this.state.loadingMasterTagExclusion },
        title: this.props.t('product-group.excluded-master-tags'),
        emptyPlaceholder: this.props.t('product-group.no-master-tags-excluded'),
        data: this.getMasterTagsForIds(group.ExcludedMasterTags),
        type: "tags"
      }
    ];

    return (
      <div className={styles.contentGrid}>
        <Grid container spacing={3}>
          {cards.map(card => {
            if (card.type === "title") {
              return (
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className={styles.sectionHeader}>{card.title}</div>
                </Grid>
              );
            }

            return (
              <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
                <Paper>
                  <ListableCard
                    actionButton={[
                      <Button
                        onClick={card.buttonAction}
                        variant="outlined"
                        color="secondary"
                      >
                        {card.add}
                      </Button>
                    ]}
                    addLabel={card.add}
                    isLoading={card.isLoading()}
                    title={card.title}
                    emptyPlaceholder={card.emptyPlaceholder}
                    handleDelete={card.handleDelete}
                    onClick={id =>
                      this.props.history.push(`/${card.type}${card.type != "tags" ? "/" + id : ""}`)
                    }
                    data={card.data == null ? [] : card.data}
                  />
                </Paper>
              </Grid>
            );
          })}
        </Grid>
      </div>
    );
  }

  handleNameChange(value) {
    if (this.state.isEditing) {
      this.setState({ name: value, changeOccurred: true });
    }
  }

  handleProductSelection(selectedProducts) {
    const shouldExclude = this.state.mode === mode.EXCLUDED_PRODUCTS;
    this.props.addEntitiesToProductGroup(
      EntityType.PRODUCT,
      [productGroupId],
      selectedProducts,
      shouldExclude,
      success => {
        if (success) {
          if (shouldExclude) {
            this.setState({ productModalOpen: false, loadingProductExclusion: true });
          } else {
            this.setState({ productModalOpen: false, loadingProductInclusion: true });
          }

          // Get the selected products...
          this.props.getProductsForIds(selectedProducts, () => {
            this.setState({ loadingProductExclusion: false, loadingProductInclusion: false });
          });
        }
      }
    );
  }

  handleProductDeletion(isExcluded, selectedProducts) {
    this.props.removeEntitiesFromProductGroup(
      EntityType.PRODUCT,
      [productGroupId],
      selectedProducts,
      isExcluded,
      success => { }
    );
    this.setState({ productDeleteModalOpen: false, productsToDelete: [] })
  }

  handleCategoryDeletion(isExcluded, selectedCategories) {
    this.props.removeEntitiesFromProductGroup(
      EntityType.CATEGORY,
      [productGroupId],
      selectedCategories,
      isExcluded,
      success => { }
    );
    this.setState({ categoryDeleteModalOpen: false, categoriesToDelete: [] })
  }

  handleCategorySelection(selectedCategories) {
    const shouldExclude = this.state.mode === mode.EXCLUDED_CATEGORIES;

    this.props.addEntitiesToProductGroup(
      EntityType.CATEGORY,
      [productGroupId],
      selectedCategories,
      shouldExclude,
      success => {
        if (success) {
          if (shouldExclude) {
            this.setState({ categoryModalOpen: false, loadingCategoryExclusion: true });
          } else {
            this.setState({ categoryModalOpen: false, loadingCategoryInclsion: true });
          }

          // Get the selected categories...
          this.props.getCategoriesForIds(selectedCategories, () => {
            this.setState({ loadingCategoryExclusion: false, loadingCategoryInclsion: false });
          });
        }
      }
    );
  }

  handleMasterTagDeletion(isExcluded, selectedMasterTags) {
    this.props.removeEntitiesFromProductGroup(
      EntityType.MASTERTAG,
      [productGroupId],
      selectedMasterTags,
      isExcluded,
      success => { }
    );
    this.setState({ masterTagDeleteModalOpen: false, masterTagsToDelete: [] })
  }

  handleMasterTagSelection(selectedMasterTags) {
    const shouldExclude = this.state.mode === mode.EXCLUDED_MASTER_TAGS;

    this.props.addEntitiesToProductGroup(
      EntityType.MASTERTAG,
      [productGroupId],
      selectedMasterTags,
      shouldExclude,
      success => {
        if (success) {
          this.setState({ masterTagModalOpen: false });
        }
      }
    );
  }

  alertDialog() {
    return (
      <AlertDialog
        title={this.props.t('common.remove-question')}
        description={this.props.t('common.remove-description')}
        options={[
          {
            label: this.props.t('common.cancel'),
            action: () => this.setState({ deleteAlertShowing: false })
          },
          { label: this.props.t('common.delete'), action: () => this.deleteGroup() }
        ]}
        isOpen={this.state.deleteAlertShowing}
      />
    );
  }

  render() {
    const group = this.state.group
    if (group == null) {
      return (
        <Box>
          <Typography>{this.props.t('product-group.incorrect-data')}</Typography>
        </Box>
      )
    }

    const content = this.getContentGrid(group);

    if (this.state.loading) {
      return < Loading />
    }

    const defaultGroups = getProductGroupDefaultType()

    return (
      <div className={styles.content} >
        <div>
          {this.alertDialog()}

          <ProductPickerModal
            handleProductSelection={selectedProducts => this.handleProductSelection(selectedProducts)}
            productModalOpen={this.state.productModalOpen}
            selected={this.state.mode === mode.EXCLUDED_PRODUCTS
              ? group.ExcludedProducts
              : group.IncludedProducts}
            setProductModalOpen={() => this.setState({ productModalOpen: false })}
          />

          <GenericPickerModal
            handleCancel={() => this.setState({ categoryModalOpen: false })}
            handleDone={selectedProducts => this.handleCategorySelection(selectedProducts)}
            open={this.state.categoryModalOpen}
            selected={
              this.state.mode === mode.EXCLUDED_CATEGORIES
                ? group.ExcludedCategories
                : group.IncludedCategories
            }
            handleSelection={() => { }}
            getAllData={(callback) => this.props.getCategories(callback)}
            searchTitle={this.props.t('category.search-category')}
            title={this.props.t('category.categories')}
            data={Object.values(this.props.categories)}
            idField="id"
            valueField="Name"
            secondaryFields={["id"]}
          />

          <GenericPickerModal
            handleCancel={() => this.setState({ masterTagModalOpen: false })}
            handleDone={selectedProducts => this.handleMasterTagSelection(selectedProducts)}
            open={this.state.masterTagModalOpen}
            selected={
              this.state.mode === mode.EXCLUDED_MASTER_TAGS
                ? group.ExcludedMasterTags
                : group.IncludedMasterTags
            }
            handleSelection={() => { }}
            getAllData={(callback) => this.props.getMasterTags(callback)}
            searchTitle={this.props.t('master-tag.search-master-tags')}
            title={this.props.t('master-tag.master-tags')}
            data={this.props.masterTags}
            secondaryFields={["id"]}
          />

          <DeleteModal
            handleCancel={() => {
              this.setState({ categoryDeleteModalOpen: false, categoriesToDelete: [] });
            }}
            handleDone={data => {
              this.handleCategoryDeletion(this.state.mode === mode.EXCLUDED_CATEGORIES, data.map(data => {
                return data.id
              }));
            }}
            data={this.getCategoriesForIds(this.state.categoriesToDelete)}
            open={this.state.categoryDeleteModalOpen}
          />

          <DeleteModal
            handleCancel={() => {
              this.setState({ productDeleteModalOpen: false, productsToDelete: [] });
            }}
            handleDone={data => {
              this.handleProductDeletion(this.state.mode === mode.EXCLUDED_PRODUCTS, data.map(data => {
                return data.id
              }));
            }}
            data={this.getProductsForIds(this.state.productsToDelete)}
            open={this.state.productDeleteModalOpen}
          />

          <DeleteModal
            handleCancel={() => {
              this.setState({ masterTagDeleteModalOpen: false, masterTagsToDelete: [] });
            }}
            handleDone={data => {
              this.handleMasterTagDeletion(this.state.mode === mode.EXCLUDED_MASTER_TAGS, data.map(data => {
                return data.id
              }));
            }}
            data={this.getMasterTagsForIds(this.state.masterTagsToDelete)}
            open={this.state.masterTagDeleteModalOpen}
          />

          <HeaderBlock
            title={
              this.state.isDefualtProductGroup ?
                (this.props.group != null ?
                  defaultGroups[this.props.group.id].label :
                  null) :
                <EditableHeading
                  value={this.state.name}
                  onChange={e => this.handleNameChange(e.target.value)}
                />
            }
            right={
              this.state.isDefualtProductGroup ?
                null :
                <Grid container spacing={2} alignItems="center" justify="flex-end">
                  <Grid item>
                    <ButtonGroup>

                      <Button
                        disabled={!this.state.isEditing}
                        onClick={() => this.setState({ deleteAlertShowing: true })}
                        variant="outlined"
                        color="primary"
                      >
                        {this.props.t('common.delete')}
                      </Button>


                      <Button
                        onClick={() => this.editGroup()}
                        variant="outlined"
                        color="secondary"
                      >
                        {this.state.isEditing ? this.props.t('common.done') : this.props.t('common.edit')}
                      </Button>
                    </ButtonGroup>
                  </Grid>
                </Grid>
            }
          />
          <PageContainer>
            {content}
          </PageContainer>
        </div>
      </div>
    );
  }
}

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
  const { group } = state.GroupReducer;
  const { products, masterTags } = state.ProductReducer;
  const { categories } = state.CategoryReducer;
  return { group, products, categories, masterTags };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getGroup,
      removeGroups,
      updateGroup,
      addEntitiesToProductGroup,
      removeEntitiesFromProductGroup,
      getCategoriesForIds,
      getProductsForIds,
      getMasterTags,
      getProducts,
      getCategories
    },
    dispatch
  );

const hoc = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(ViewProductGroupingPage))
);

// EXPORT COMPONENT

export { hoc as ViewProductGroupingPage };

